import angular from 'angular';
import uiRouter from 'angular-ui-router';
import VendorComponent from './vendor.component';
import routing from './vendor.routes';

export default angular
  .module('verifyApp.cases.vendor', [uiRouter])
  .config(routing)
  .component('vendor', VendorComponent)
  .name;



// WEBPACK FOOTER //
// ./client/app/cases/vendor/index.js